<template>

  <div class="selected-container" v-wechat-title="'mysread'">

    <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700"/>

    <!--banner-->
    <div class="banner-container">
      <img @click="getBookDetail(banner[0].url)" :src="bannerImage" alt="">
    </div>

    <!--客戶端下載-->
    <div @click="jumpDownloadView" class="client-download-container">
      <a>點擊下載立異app</a>
    </div>

    <!--slider-->
    <div class="slider-container">
      <div class="book-display-container" v-for="book in slide">
        <div @click="getBookDetail(book.id)">
          <img :src="book.pic1" alt=""/>
          <span style="color: #333333">{{ book.title }}</span>
          <span>作者:{{ book.author }}</span>
        </div>
      </div>
    </div>

    <!--分割線-->
    <div style="width: 100%;height: 10px;background-color: lightgray"></div>

    <!--hotSale-->
    <div class="hot-sale-container">
      <div style="padding: 10px 10px 0;">
        <span style="float: left;font-weight: bold">本期熱銷</span>
        <img src="../assets/img_change.png" @click="changeHotSale" class="change-hot-sale">
      </div>
      <div style="display: flex;flex-wrap: wrap">
        <div class="book-display-container" v-for="book in hotSale">
          <div @click="getBookDetail(book.id)">
            <img :src="book.pic1" alt=""/>
            <span style="color: #333333">{{ book.title }}</span>
            <span>作者:{{ book.author }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--分割線-->
    <div style="width: 100%;height: 10px;background-color: lightgray"></div>

    <!--hotFinish-->
    <div class="hot-sale-container">
      <div style="padding: 10px 10px 0;">
        <span style="float: left;font-weight: bold">火爆完結</span>
      </div>
      <div style="display: flex;flex-wrap: wrap">
        <div class="book-display-container" v-for="book in hotFinished" style="width: 25%">
          <div @click="getBookDetail(book.id)">
            <img :src="book.pic1" alt=""/>
            <span style="color: #333333">{{ book.title }}</span>
            <span>作者:{{ book.author }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--分割線-->
    <div style="width: 100%;height: 10px;background-color: lightgray"></div>

    <!--bookRecommend-->
    <div class="hot-sale-container">
      <div style="padding: 10px 10px 0;">
        <span style="float: left;font-weight: bold">新文推薦</span>
      </div>
      <div style="display: flex;flex-wrap: wrap">
        <div class="book-display-container" v-for="book in bookRecommend">
          <div @click="getBookDetail(book.id)">
            <img :src="book.pic1" alt=""/>
            <span style="color: #333333">{{ book.title }}</span>
            <span>作者:{{ book.author }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--分割線-->
    <div style="width: 100%;height: 10px;background-color: lightgray"></div>

    <!--discount-->
    <div class="hot-sale-container">
      <div style="padding: 10px 10px 0;">
        <span style="float: left;font-weight: bold">打折專區</span>
      </div>

      <div class="discount-container">
        <ul>
          <div v-for="discount in discountList">
            <li @click="discountClick(discount.discount)">
              <div style="display: flex;flex-direction: row">
                <div>
                  <span>{{ discount.title }}</span>
                  <span style="color: #999999;font-size: 14px">{{ discount.content }}</span>
                  <span style="color: #f2c510">{{ discount.discount }}折專區</span>
                </div>
                <img :src="discount.pic1" alt="">
              </div>
              <div style="width: 100%;height: 1px;background-color: lightgray"></div>
            </li>
          </div>
        </ul>
      </div>
    </div>

    <!--分割線-->
    <div style="width: 100%;height: 10px;background-color: lightgray"></div>
    <div>
      <p style="color:#908D8DFF">{{ company.name }}</p>
      <p style="color:#908D8DFF">{{ company.address }}</p>
      <p style="color:#908D8DFF">{{ company.email }}</p>
    </div>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "SelectedVue",

  data() {
    return {
      banner: [],
      bookRecommend: [],
      discountList: [],
      hotFinished: [],
      slide: [],
      hotSale: [],
      hotSalePage: 1,
      bannerImage: "",
      isCreate: false,
      isRequest: false,
      company: {
        name: "南昌水分子運動俱樂部有限公司",
        address: "地址：江西省南昌市南昌縣象湖新城金沙大道2004號31棟",
        email: "tktw001@outlook.com"
      }
    };
  },
  methods: {
    //跳轉到下載界面
    jumpDownloadView: function () {
      this.$router.push({
        path: "DownloadVue",
      });
    },

    //獲取精選數據
    getSelectedData: function () {
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "getChosen");
      this.isRequest = true;
      this.$http.post(axios.baseURL, params).then((res) => {
        this.isRequest = false;
        if (res.data.status) {
          this.banner = res.data.data.banner;
          this.bannerImage = this.banner[0].pic1;
          this.bookRecommend = res.data.data.bookRecommend;
          this.discountList = res.data.data.discount;
          this.hotFinished = res.data.data.hotFinished;
          this.slide = res.data.data.slide;
        } else {
          alert(res.data.msg);
        }
      });
    },

    //獲取本期熱銷數據
    getHotSaleData: function () {
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "getChosenHotSale");
      params.append("page", this.hotSalePage);
      this.isRequest = true;
      this.$http.post(axios.baseURL, params).then((res) => {
        this.isRequest = false;
        if (res.data.status) {
          if (this.hotSalePage === 1) {
            this.hotSalePage = 2;
          } else {
            this.hotSalePage = 1;
          }
          this.hotSale = res.data.data;
        } else {
          alert(res.data.msg);
        }
      });
    },

    //獲得公司消息
    getCompanyInfo: function () {
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "getCompanyInfo");
      this.$http.post(axios.baseURL, params).then((res) => {
        if (res.data.status) {
          this.company = res.data.data;
        }
      });

    },
    //換壹換
    changeHotSale: function () {
      this.isRequest = true;
      this.getHotSaleData();
    },

    //獲取書籍詳情
    getBookDetail: function (bookId) {
      this.$router.push({
        path: "BookDetailVue",
        query: {
          bookId: bookId,
          vueName: "SelectedVue",
        },
      });
    },

    //九折專區
    discountClick: function (type) {
      if (type === 9) {
        this.$router.push({
          path: "SingleDiscountVue",
        });
      } else if (type === 6) {
        this.$router.push({
          path: "PackageDiscountVue",
        });
      }
    },
  },

  created() {
    this.isCreate = true;
    this.getSelectedData();
    this.getHotSaleData();
    this.getCompanyInfo();
  },

  beforeRouteEnter(to, from, next) {
    to.meta.isBack = from.name === "BookDetail" || "SearchVue";
    next();
  },

  activated() {
    // 如果isBack是false 、isCreate也為false，表明需要獲取新數據
    if (!this.$route.meta.isBack && !this.isCreate) {
      //防止進入頁面重新獲取數據的時候還是在之前進入頁面的位置
      window.scrollTo(0, -1);
      this.getSelectedData();
      this.getHotSaleData();
    }
    // 恢復成默認的false，避免isBack壹直是true，導致下次無法獲取數據
    this.$route.meta.isBack = false;
    //重置isCreate為false ,避免isCreate壹直是true，導致下次無法獲取數據
    this.isCreate = false;
  },
};
</script>

<style scoped>
.selected-container {
  margin-top: 50px;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 100px);
  -webkit-overflow-scrolling: touch;
}

.banner-container {
  width: 100%;
}

.banner-container img {
  width: 100%;
}

.slider-container {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  padding-bottom: 10px;
}

.hot-sale-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.discount-container {
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.discount-container ul {
  text-align: left;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 10px;
  margin-top: 10px;
}

.discount-container ul li {
  list-style: none;
  position: relative;
  padding: 10px;
  cursor: pointer;
}

.discount-container ul li span {
  display: block;
  line-height: 30px;
  font-size: 18px;
}

.discount-container ul li img {
  width: 40%;
  top: -5%;
  position: absolute;
  right: 10px;
}

.change-hot-sale {
  cursor: pointer;
  float: right;
  color: #ea477b;
  width: 15%;
}

.change-hot-sale :active {
  transform: scale(0.9);
}

.client-download-container {
  text-align: center;
  margin: 10px 10%;
  display: flex;
  flex-direction: column;
}

.client-download-container a {
  margin-top: 10px;
  height: 30px;
  background-color: firebrick;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: white;
  line-height: 30px;
}

.client-download-container a:active {
  background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectedVue.vue